module.exports = __webpack_public_path__ + "img/yml_gallery3.b39a5d29.jpg";